export const profiles = Object.freeze({
    Generic: 0,
    OralWritternBoard: 1,
    OpenEvent: 2,
    PSTM: 3
});
export const tzMappings = {
    'hst': 'America/Adak',
    'hdt': 'America/Adak',
    'akst': 'America/Anchorage',
    'akdt': 'America/Anchorage',
    'mst': 'America/Denver',
    'mdt': 'America/Denver',
    'cst':'America/Chicago',
    'cdt':'America/Chicago',
    'est':'America/New_York',
    'edt':'America/New_York',
    'pst': 'America/Los_Angeles',
    'pdt': 'America/Los_Angeles',
    'utc': 'Etc/UTC',
    'gmt': 'Etc/UTC'
}